export default {"src":"/_next/static/media/arrow.4b2d2504.svg","height":10,"width":15,"blurWidth":0,"blurHeight":0};